import script from "./NewsPagePopupSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPagePopupSidebar.vue?vue&type=script&setup=true&lang=js"

import "./NewsPagePopupSidebar.vue?vue&type=style&index=0&id=5438f83a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5438f83a"]])

export default __exports__